namespace GeniuzPOS.Inventory {
    export interface IcStockReturnInRow {
        Id?: number;
        SysDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        StockFrom?: string;
        CustName?: string;
        WhsId?: string;
        WhsName?: string;
        Remark?: string;
        PostFg?: PostFgStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ReturnInDtList?: IcStockReturnInDtRow[];
        CancelFg?: CancelFgstatus;
        CheckQty?: number;
    }

    export namespace IcStockReturnInRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockReturnIn';
        export const lookupKey = 'Inventory.IcStockReturnIn';

        export function getLookup(): Q.Lookup<IcStockReturnInRow> {
            return Q.getLookup<IcStockReturnInRow>('Inventory.IcStockReturnIn');
        }
        export const deletePermission = '2Inventory:รายการ:รับคืน:Modify';
        export const insertPermission = '2Inventory:รายการ:รับคืน:Modify';
        export const readPermission = '2Inventory:รายการ:รับคืน:View';
        export const updatePermission = '2Inventory:รายการ:รับคืน:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            StockFrom = "StockFrom",
            CustName = "CustName",
            WhsId = "WhsId",
            WhsName = "WhsName",
            Remark = "Remark",
            PostFg = "PostFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ReturnInDtList = "ReturnInDtList",
            CancelFg = "CancelFg",
            CheckQty = "CheckQty"
        }
    }
}
